<template>
  <div class="d-flex justify-space-between">
    <v-text-field
      v-model.lazy="phonePrefix"
      v-on:input="prefixValueChanged"
      :label="$t('global.phone.countryPrefix')"
      filled
      class="shrink"
      prefix="+"
      :maxlength="5"
      :rules="computedRules([rules.phonePrefix])"
    >
    </v-text-field>
    <v-text-field
        ref="phoneNumberField"
        v-model.lazy="phoneNumber"
        v-on:input="phoneValueChanged"
        :label="label"
        filled
        :rules="computedRules([rules.phone])"
        class="ml-2"
        :class="{'required': required}">
    </v-text-field>
  </div>
</template>

<script>
import {phonePrefixRule, phoneRule, requiredRule} from "@/helpers/validationRules";

export default {
  props: {
    label: { type: String, required: true },
    value: { type: String, required: false },
    required: { type: Boolean, required: false, default: false }
  },
  mounted() {
    this.updatePhoneNumberWithValue()
  },
  data() {
    return {
      phonePrefix: '41',
      phoneNumber: '',
      rules: {
        required: requiredRule,
        phone: (value) => phoneRule(this.phonePrefix, value),
        phonePrefix: (value) => phonePrefixRule(value)
      },
    }
  },
  watch: {
    value: {
      handler() {
        this.updatePhoneNumberWithValue()
      },
      deep: true
    },
  },
  methods: {
    updatePhoneNumberWithValue() {
      if (this.value && this.value.trim() !== '') {
        if (this.value.includes('/')) {
          const splittedValue = this.value.replace("+", "").split('/');
          this.phonePrefix = splittedValue[0] || '41';
          this.phoneNumber = splittedValue[1] || '';
        } else {
          if (this.value.length > 0) {
            // to be retro-compatible with older version without "/" in phone numbers, we assume that prefix size was 2
            this.phonePrefix = this.value.slice(1, 3) || '41';
            this.phoneNumber = this.value.slice(3);
            this.$emit('input', `+${(this.phonePrefix || '41').replace(/\s/g, "")}/${(this.phoneNumber || '').replace(/\s/g, "")}`);
          }
        }
      } else {
        this.phonePrefix = '41';
        this.phoneNumber = '';
        this.$emit('input', `+${(this.phonePrefix || '41').replace(/\s/g, "")}/${(this.phoneNumber || '').replace(/\s/g, "")}`);
      }
    },
    computedRules(rules) {
      if (this.required === true) {
        return [...rules, this.rules.required];
      }
      return  [...rules];
    },
    prefixValueChanged(prefix) {
      if (!prefix) return;
      if (this.phoneNumber?.length > 0) {
        this.$emit('input', `+${prefix.replace(/\s/g, "")}/${this.phoneNumber.replace(/\s/g, "")}`);
      } else {
        this.$emit('input', `+${prefix.replace(/\s/g, "")}/`);
      }

    },
    phoneValueChanged(value) {
      this.$emit('input', `+${(this.phonePrefix || '41').replace(/\s/g, "")}/${(value || '').replace(/\s/g, "")}`);
    }
  }
}
</script>
<style lang="scss">
</style>
